/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProfileNewsletterDeleteContact$Params {
  id: number;
  email: string;
}

export function profileNewsletterDeleteContact(http: HttpClient, rootUrl: string, params: ProfileNewsletterDeleteContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterDeleteContact.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

profileNewsletterDeleteContact.PATH = '/rest/profile/{id}/newsletter/contact/{email}';
